var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center text-gray-subtle-text"},[_c('CUIcon',{staticClass:"h-20 w-20 margin-r-1",attrs:{"view-box":"0 0 24 24"}},[_vm._v(" groups ")]),_vm._v(" Up to "),_c('span',{staticClass:"margin-x-1 font-medium"},[_vm._v(_vm._s(_vm.capacity))]),_vm._v(" passengers ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }